import React from 'react';
import { cn } from '@/lib/utils';

export const PageHeader = ({
  title,
  subtitle,
  breadcrumb,
  backgroundImage,
  className,
}) => {
  return (
    <section
      className={cn(
        'relative py-24 md:py-32 overflow-hidden',
        className
      )}
    >
      {/* Background */}
      <div className="absolute inset-0">
        {backgroundImage ? (
          <>
            <img
              src={backgroundImage}
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gray-900/80" />
          </>
        ) : (
          <div className="w-full h-full bg-gray-900" />
        )}
        {/* Pattern overlay */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-600 rounded-full blur-3xl" />
        </div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {breadcrumb && (
          <div className="mb-4 text-sm text-gray-400">
            <span className="text-red-500">Home</span>
            <span className="mx-2">/</span>
            <span>{breadcrumb}</span>
          </div>
        )}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>

      {/* Red accent bar */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-red-600" />
    </section>
  );
};

export default PageHeader;
